
import MapView from './components/map-view.vue';
import SearchView from './components/search-view.vue';
import ResultsView from './components/results-view.vue';
import DetailsView from './components/details-view.vue';
import RoutingView from './components/routing-view.vue';
import LogosCarousel from './components/welcomeParts/logos-carousel.vue';
import LocalizeBtn from './components/localize-btn.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';
import apiLoader from './lib/apiLoader';
import { getDeviceClassName, setRootElement, getAllDeviceClassNames, allowDevices } from './lib/core/responsive';
import { getConfig } from './lib/ConfigLoader';
import { container } from './lib/container';
import { AppBehavior } from './lib/core/AppBehavior';
import { GPS } from './lib/core/GPS';

const gps = container.get<GPS>('gps');
const behavior = container.get<AppBehavior>('behavior');

@Component({
	components: {
		SearchView,
		ResultsView,
		MapView,
		DetailsView,
		RoutingView,
		LogosCarousel,
		LocalizeBtn
	}
})
export default class StoreFinder extends Vue {
	@Prop() width!: string;
	@Prop() height!: string;
	@Prop({ required: true })
	apiKey!: string;
	@Prop({ required: true })
	lng!: number | string;
	@Prop({ required: true })
	lat!: number | string;
	@Prop({ required: true })
	zoom!: number | string;
	@Prop()
	bbox!: string;
	@Prop() showWelcomeParts!: boolean;

	isNotScrollable: boolean = false;

	apiStatus: 'idle' | 'loading' | 'ready' = 'idle';
	modules: any = null;

	$refs!: {
		mainContainer: HTMLDivElement;
		controlContainer: HTMLDivElement;
	};

	mainClassNames: { [key: string]: boolean } = { 'ym-store-finder': true };

	onSearchMount(el: HTMLElement) {
		// this.$refs.controlContainer.style.height = 'calc(100% - ' + (el.offsetHeight + 1) + 'px)';
	}

	recalculateSize() {
		if (this.$refs.mainContainer) {
			const config = getConfig();
			setRootElement(this.$refs.mainContainer);
			this.isNotScrollable =
				!config.resultsView.scrolling.autoScroll || !allowDevices(config.resultsView.scrolling.sizes);
			const deviceClassName = getDeviceClassName();
			const allClasses = getAllDeviceClassNames();
			for (const name of allClasses) {
				this.mainClassNames[name] = deviceClassName === name;
			}
		}
		return {
			// width: this.width || '100%',
			// height: this.height || '100%'
		};
	}

	async created() {
		if (this.apiStatus === 'idle') {
			this.apiStatus = 'loading';
			this.modules = await apiLoader(this.apiKey);

			const experimental = (ym.services as any).exp;
			if (experimental) {
				if (experimental.google) {
					ym.autoComplete = experimental.google.autoComplete;
				} else if (experimental.yellowmaps) {
					ym.autoComplete = experimental.yellowmaps.autoComplete;
				}
			}
			this.apiStatus = 'ready';

			if (behavior.appView) {
				gps.localize();
			}
		}
	}

	mounted() {
		this.$router.afterEach(() => this.recalculateSize());
		this.$nextTick(() => {
			this.recalculateSize();
			window.addEventListener('resize', () => {
				this.recalculateSize();
			});
		});
	}

	updated() {
		this.recalculateSize();
	}
}
